import {defineStore} from 'pinia'
import axios from '@/api/axios'

export const useSmartnewsBusinessManagerStore = defineStore({
  id: 'smartnewsBusinessManagerStore',
  state: () => ({
    smartnewsBusinessManagers: [],
    smartnewsBusinessManagersLoading: false,
    error: null,
  }),
  actions: {
    async getSmartnewsBusinessManagers(filters = {}, withRelation = undefined) {
      this.error = null
      this.smartnewsBusinessManagersLoading = true

      try {
        const {data} = await axios.get('smart-news/business-managers', {
          params: {...filters, with: withRelation},
        })

        this.smartnewsBusinessManagers = data

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.smartnewsBusinessManagersLoading = false
      }
    },

    async createSmartnewsBusinessManager(payload) {
      this.error = null
      this.smartnewsBusinessManagersLoading = true

      try {
        const {data} = await axios.post('smart-news/business-managers', payload)

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.smartnewsBusinessManagersLoading = false
      }
    },

    async updateSmartnewsBusinessManager(id, payload) {
      this.error = null
      this.smartnewsBusinessManagersLoading = true

      try {
        let {data} = await axios.patch(`smart-news/business-managers/${id}`, payload)

        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.smartnewsBusinessManagersLoading = false
      }
    },

    async updateSmartnewsBusinessManagerProviders(hash, payload) {
      const {data} = await axios.patch(`smart-news/business-managers/${hash}/providers`, payload)

      return data
    },

    async getSmartnewsProviders(filters = {}) {
      this.error = null
      this.loading = true

      try {
        const {data} = await axios.get('smart-news/providers', {params: filters})
        return data
      } catch (responseError) {
        this.error = responseError?.data
      } finally {
        this.loading = false
      }
    },
  },
})
